module.exports = __webpack_public_path__ + "img/03.3ee1b850.svg";